import { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomSelect from "../../../common/CustomSelect";
import CustomTextArea from "../../../common/CustomTextArea";
import CustomActionButton from "../../../common/CustomActionButton";
import { UpdateIndiProgram } from "../../../redux/program/actions";

function ProgramInfo(props) {
    const { program } = props;
    const [programInfo, setProgramInfo] = useState({
    });

    useEffect(() => {
        setProgramInfo(pi => program);
    }, [program?.id]);

    const handleChange = (e) => {

        setProgramInfo({
            ...programInfo,
            [e.target.name]: e.target.value,
        });
    }


    return (
        <div id="ip-program-info" className="custom-modal-content-wrapper">
            <div className="row cmcw-card">
                <div className="col-md-8 mb-4">
                    <h5>Title</h5>
                    <CustomInputV2
                        required={true}
                        value={program?.title}
                        type="text"
                        onChange={handleChange}
                        name="title"
                    />

                </div>

                <div className="col-md-4 mb-4">
                    <h5>Type</h5>

                    <CustomSelect
                        options={[
                            { label: "Strength", value: "strength" },
                            { label: "Mobility", value: "mobility" },
                            { label: "Focus", value: "focus" },
                            { label: "Focus", value: "focus" },
                            { label: "Athletics", value: "athletics" },
                        ]}
                        value={program?.type}
                        onChange={handleChange}
                        name="type"
                    />
                </div>

                {
                    (!program?.beginner && !program?.moderate && !program?.advanced) &&
                    <div className="col-md-12 mb-2 mt-4">
                        <h5>Description</h5>
                        <CustomTextArea name="info" value={program?.info} onChange={handleChange} />
                    </div>
                }

                {
                    program?.beginner &&
                    <div className="col-md-12 mb-2 mt-4">
                        <h5>Beginner</h5>
                        <CustomTextArea name="beginner" value={program?.beginner} onChange={handleChange} />
                    </div>
                }

                {
                    program?.moderate &&
                    <div className="col-md-12 mb-2">
                        <h5>Moderate</h5>
                        <CustomTextArea name="moderate" value={program?.moderate} onChange={handleChange} />
                    </div>
                }

                {
                    program?.advanced &&
                    <div className="col-md-12 mb-2">
                        <h5>Advanced</h5>
                        <CustomTextArea name="advanced" value={program?.advanced} onChange={handleChange} />
                    </div>
                }


                <div className="col-md-12 mb-4 flex-r" id="program-actions">
                    <CustomActionButton action={async () => {
                        const toastID = toast.loading("Updating Program...");
                        const res = await props?.UpdateIndiProgram(programInfo);

                        if (res) {
                            toast.success("Program Updated!", { id: toastID });
                        } else {
                            // error
                            toast.error("Failed to update program", { id: toastID });
                        }

                        return res;
                    }}>
                        Save
                    </CustomActionButton>
                </div>

            </div>
        </div>
    );
}


const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    UpdateIndiProgram,
})(ProgramInfo);
